import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { DomainRegistrarsSearchingForm, useGetAllDomainRegistrarsQuery } from '@/modules/DomainRegistrars';

import { DomainRegistrarsListView } from './DomainRegistrarsListView';

export const DomainRegistrarsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: domainRegistrarsListData,
    error: domainRegistrarsListError,
    isLoading: isDomainRegistrarsListLoading,
    isFetching: isDomainRegistrarsListFetching,
    isError: isDomainRegistrarsListError
  } = useGetAllDomainRegistrarsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isDomainRegistrarsListLoading }
      error={ domainRegistrarsListError }
      isError={ isDomainRegistrarsListError }
      data={ domainRegistrarsListData }
    >
      { (domainRegistrarsList): ReactElement => (
        <>
          <DomainRegistrarsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <DomainRegistrarsListView
            currentPage={ currentPage }
            domainRegistrarsListItems={ domainRegistrarsList.items }
            domainRegistrarsListTotalItems={ domainRegistrarsList.meta.totalItems }
            domainRegistrarsListItemsPerPage={ domainRegistrarsList.meta.itemsPerPage }
            isLoading={ isDomainRegistrarsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
